import { Language } from "../languages/labels/language.labels";

export function statusDocumentInboxList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'new', display: lang.labels.new },
    { code: 'assigned', display: lang.labels.assigned },
    { code: 'partially-processed', display: lang.labels.partiallyProcessed },
    { code: 'processed', display: lang.labels.processed }
  ]
}

export function statusDocumentInboxValue(lang: Language, code: string): string {
  let status = statusDocumentInboxList(lang).find((item) => (item.code === code))
  return status ? status.display : lang.labels.undefined
}
